module.exports = __webpack_public_path__ + "img/whatsapp.f117e4f6.svg";